import debounce from '../util/debounce';

const hitsWithNoQuery = 3;
const hitsWithQuery = 4;
const imageSrcPrepend =
  window.cece.django_env !== 'production' &&
  window.cece.algolia.indexName.startsWith('production_')
    ? 'https://www.projectcece.nl'
    : '';

let resultCache;
let queryCache;

const debounced = debounce(items => Promise.resolve(items), 100);

export function createProductSearchPlugin({ searchClient }) {
  return {
    getSources({ query }) {
      return debounced([
        {
          sourceId: 'products',
          async getItems() {
            // Check cache
            if (resultCache && query === queryCache) return resultCache;

            // Request data
            const result = await searchClient
              .collections(window.cece.typesense.collectionName)
              .documents()
              .search({
                q: query || '*',
                query_by: 'title,text',
                filter_by: `visible:true && country_site_codes:${
                  window.cece.siteCountryCode
                }${
                  window.cece.searchSection
                    ? ' && section_names:' + window.cece.searchSection
                    : ''
                }`,
                limit_hits: query ? hitsWithQuery : hitsWithNoQuery,
                per_page: query ? hitsWithQuery : hitsWithNoQuery,
              });

            // Cache and return
            queryCache = query;
            resultCache = result.hits.map(h => h.document);
            return resultCache;
          },
          templates: {
            header() {
              return window.i18n.header.searchProductsHeader;
            },
            item({ item, createElement }) {
              return createElement(
                'div',
                { class: 'catalog-search-item' },
                createElement(
                  'div',
                  {
                    class: 'thumbnail',
                  },
                  createElement(
                    'div',
                    {
                      class: 'image-ratio-3-4',
                    },
                    createElement('img', {
                      src:
                        imageSrcPrepend +
                        (item.main_image_urls
                          ? item.main_image_urls.default.default
                          : item.main_image_url),
                    })
                  )
                ),
                createElement(
                  'a',
                  {
                    class: 'content',
                    href: `/catalog/product/${item.product_id}/${item.slug}/`,
                  },
                  item.title
                  // components.Highlight({
                  //   hit: item,
                  //   attribute: 'title',
                  //   tagName: 'mark',
                  // })
                )
              );
            },
          },
        },
      ]);
    },
  };
}
